<template>
	<button @click="onClick" class="btn" :class="[loading ? 'loading' : '', cls]">
		<div class="spinner"><div class="spinner-circle"></div></div>
		<span><slot></slot></span>
	</button>
</template>

<script setup>
import { inject } from '@vue/runtime-core'

const props = defineProps({
	loading: {
		type: Boolean,
		default: false
	},
	cls: {
		default: 'btn-primary'
	},
	title: {
		type: String
	},
	path: {
		type: Array,
		default: () => []
	},
	eventName: {
		type: String,
		default: 'ButtonClick'
	}
})

const amplitude = inject('amplitude')
const onClick = () => {
	if (props.title) {
		amplitude.logEvent(props.eventName, {
			title: props.title,
			path: props.path
		})
	}
}
</script>
